/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamIdRejectionReason } from './oralExamIdRejectionReason';
import type { OralExamRejectIdVerificationRequestNote } from './oralExamRejectIdVerificationRequestNote';

/**
 * Body for lecturer rejection of a student's ID verification.
 */
export interface OralExamRejectIdVerificationRequest {
  reasonCode: OralExamIdRejectionReason;
  note?: OralExamRejectIdVerificationRequestNote;
}
